import { render, staticRenderFns } from "./ContributorsList.vue?vue&type=template&id=44a98fe7&scoped=true&"
import script from "./ContributorsList.vue?vue&type=script&lang=js&"
export * from "./ContributorsList.vue?vue&type=script&lang=js&"
import style0 from "./ContributorsList.vue?vue&type=style&index=0&id=44a98fe7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a98fe7",
  null
  
)

export default component.exports